import useSWR, { mutate } from "swr"
import { pluralize } from "web/services/inflector"

import API from "./api"

export default function usePhotos({ subjectType, subjectId }) {
  const key = `${pluralize(subjectType)}/${subjectId}/attachments/images`

  const {
    data: attachments,
    error,
    mutate: refresh,
  } = useSWR(key, API.get, {
    suspense: true,
  })

  if (error) return undefined

  async function add(files, params) {
    const attachments = await API.postFileUpload(key, files, params)
    mutate(key)

    return attachments
  }

  attachments.add = add
  attachments.refresh = refresh

  return attachments
}
